import { EditButton, ShowButton, useRecordContext } from "react-admin";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { DormitoryAccommodationOrderStatuses } from "utils/constants";
import CancelDialog from "./CancelDialog";

export const AccommodationOrderShowAction = () => <ShowButton label="Преглед" />;

export const AccommodationOrderEditAction = () => {
  const record = useRecordContext();
  const isDraft = record?.status === DormitoryAccommodationOrderStatuses.Draft;

  if (!isDraft) return null;

  return (
    <SecuredComponent permission={permissions.canManageDormitoryAccommodationOrders}>
      <EditButton label="Редактирай" />
    </SecuredComponent>
  );
};

export const AccommodationOrderCancelAction = () => {
  const record = useRecordContext();
  const isDraft = record?.status === DormitoryAccommodationOrderStatuses.Draft;

  if (!isDraft) return null;

  return (
    <SecuredComponent permission={permissions.canManageDormitoryAccommodationOrders}>
      <CancelDialog />
    </SecuredComponent>
  );
};

const AccommodationOrderActions = () => (
  <>
    <AccommodationOrderShowAction />
    <AccommodationOrderEditAction />
    <AccommodationOrderCancelAction />
  </>
);

export default AccommodationOrderActions;
